import gql from 'graphql-tag';

const createOrUpdateDealerInformationMutation = gql`
  mutation CreateOrUpdateDealerInformation(
    $dealerInformation: DealerInformationInputObjectType!
  ) {
    createOrUpdateDealerInformation(
      input: { dealerInformation: $dealerInformation }
    ) {
      success
      errors
      msg
    }
  }
`;

export default createOrUpdateDealerInformationMutation;
